import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { updatePantryState } from './pantry.service'
import { showToast } from '@/shared/utils/toast'
import type { Ingredient, PantryState } from './types'

export function useUpdatePantryState() {
  const queryClient = useQueryClient()
  const { t } = useTranslation('pantry')

  return useMutation({
    mutationFn: ({ id, pantryState }: { id: string; pantryState: PantryState }) =>
      updatePantryState(id, pantryState),
    onMutate: async ({ id, pantryState }) => {
      await queryClient.cancelQueries({ queryKey: ['pantry', 'ingredients'] })
      const prev = queryClient.getQueryData<Ingredient[]>(['pantry', 'ingredients'])
      queryClient.setQueryData<Ingredient[]>(['pantry', 'ingredients'], (old) =>
        old?.map((ing) => (ing.id === id ? { ...ing, pantryState } : ing)) ?? [],
      )
      return { prev }
    },
    onError: (_err, _vars, ctx) => {
      queryClient.setQueryData(['pantry', 'ingredients'], ctx?.prev)
      showToast(t('error.updateFailed'))
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['pantry', 'ingredients'] })
    },
  })
}
